const Gray = {
  Gray: {
    _000: '#FAFAFA',
    _100: '#F4F4F5',
    _200: '#E4E4E7',
    _300: '#D4D4D8',
    _400: '#A1A1AA',
    _500: '#71717A',
    _600: '#52525B',
    _700: '#3F3F46',
    _800: '#27272A',
    _900: '#18181B',
  },
  CoolGray: {
    _000: '#F9FAFB',
    _100: '#F3F4F6',
    _200: '#E5E7EB',
    _300: '#D1D5DB',
    _400: '#9CA3AF',
    _500: '#6B7280',
    _600: '#4B5563',
    _700: '#374151',
    _800: '#1F2937',
    _900: '#111827',
  },
  BlueGray: {
    _000: '#F8FAFC',
    _100: '#F1F5F9',
    _200: '#E2E8F0',
    _300: '#CBD5E1',
    _400: '#94A3B8',
    _500: '#64748B',
    _600: '#475569',
    _700: '#334155',
    _800: '#1E293B',
    _900: '#0F172A',
  },
  TrueGray: {
    _000: '#FAFAFA',
    _100: '#F5F5F5',
    _200: '#E5E5E5',
    _300: '#D4D4D4',
    _400: '#A3A3A3',
    _500: '#737373',
    _600: '#525252',
    _700: '#404040',
    _800: '#262626',
    _900: '#171717',
  },
  WarmGray: {
    _000: '#FAFAF9',
    _100: '#F5F5F4',
    _200: '#E7E5E4',
    _300: '#D6D3D1',
    _400: '#A8A29E',
    _500: '#78716C',
    _600: '#57534E',
    _700: '#44403C',
    _800: '#292524',
    _900: '#1C1917',
  },
};

export default Gray;
